import { agentsVerificationsApi } from '../../../data/agentsVerificationsApi';
import type { EvaBenefitsConfigType } from './evaBenefitsConfigType';

/**
 * eva feature endpoint, injected into the agents module's Verifications base api.
 * Owns the read for HMO/OON routing rules, Medicare deductibles, service type codes, and
 * calculation defaults shown across the Configuration detail views.
 */
const evaConfigEndpoints = agentsVerificationsApi.injectEndpoints({
  endpoints: (builder) => ({
    getEvaBenefitsConfig: builder.query<EvaBenefitsConfigType, void>({
      query: () => 'verification/eva/config',
      providesTags: ['Verification'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetEvaBenefitsConfigQuery } = evaConfigEndpoints;
